export default __webpack_public_path__ + "static/media/es-pv.e0d4c3c3.svg";